import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSnackbar } from "notistack";
import Dropzone from "react-dropzone-uploader";
import { Paper } from "@material-ui/core";
import { getProjectCierre } from "../../services/projectFileServices";
import "react-dropzone-uploader/dist/styles.css";

const PanelFilesActaCierre = ({ projectSlug, projectId }) => {
  const apiEndPoint = process.env.REACT_APP_API_URL;
  const { enqueueSnackbar } = useSnackbar();

  const styles = {
    dropzone: { width: "23em", height: "12em" },
    dropzoneActive: {
      borderColor: "green",
      inputContent: "Soltar el archivo",
    },
    inputLabel: {
      color: "#00aae4",
      fontFamily: "Tahoma",
      fontSize: "11px",
    },
  };

  //ACTA DE CIERRE

  let [cierre, setCierre] = useState(null);

  // specify upload params and url for your files
  const getUploadParamsC = ({ meta }) => {
    return { url: `${apiEndPoint}/projects/${projectSlug}/cierre` };
  };

  const handleChangeStatusC = (
    { meta, remove, file },
    status,
    fileWithMeta
  ) => {
    if (status === "done") {
      //enqueueSnackbar(`${meta.name} fue subido correctamente! Detalle: ${fileWithMeta[0].xhr.response}`, { variant: 'success' });
      enqueueSnackbar(`${meta.name} fue subido correctamente!`, {
        variant: "success",
      });
      setCierre(JSON.parse(fileWithMeta[0].xhr.response));
      remove();
    } else if (status === "aborted") {
      enqueueSnackbar(
        `${meta.name} no se subió! Detalle: ${fileWithMeta[0].xhr.response}`,
        { variant: "error" }
      );
    } else if (status === "error_file_size") {
      enqueueSnackbar(`Error! Detalle: Tamaño máximo permitido es 2MB.`, {
        variant: "error",
      });
    } else if (status === "error_upload") {
      enqueueSnackbar(
        `Error! Detalle: Tamaño máximo permitido es 2MB y debe ser PDF.`,
        { variant: "error" }
      );
    } else if (status === "rejected_file_type") {
      enqueueSnackbar(
        `${meta.name} no se subió! Detalle: Solo se aceptan archivos en formato PDF`,
        { variant: "error" }
      );
    }
  };

  const handleOpenPDFC = (event) => {
    event.preventDefault();
    if (cierre !== null) window.open(cierre);
  };

  useEffect(() => {
    const populateCierre = async () => {
      const { data: project } = await getProjectCierre(projectSlug);
      setCierre(project.cierre);
    };

    populateCierre();
  }, [projectSlug]);

  return (
    <>
      <Paper className="paper">
        <h2>Acta de Cierre: </h2>

        <Dropzone
          getUploadParams={getUploadParamsC}
          onChangeStatus={handleChangeStatusC}
          maxFiles={1}
          multiple={false}
          canCancel={false}
          styles={styles}
          inputContent="Arrastrar aquí el PDF para subirlo"
          maxSizeBytes={20000000} // 20MB
          accept=".pdf"
          autoUpload={false}
        />

        <small style={{ color: "white" }}>
          {" "}
          <br />
          <br />{" "}
        </small>

        {cierre === null ? (
          "No existe ningun archivo"
        ) : (
          <Link to="#" onClick={handleOpenPDFC}>
            {cierre === null ? " " : "Abrir Acta de Cierre"}
          </Link>
        )}
      </Paper>
    </>
  );
};

export default PanelFilesActaCierre;
